module.exports = __webpack_public_path__ + "static/img/oppoReno3Pro_5G.2b01e095.png";